module.exports = __webpack_public_path__ + "static/newspaper-3711a9435596afcc6996aa0c1e11e71b.jpg";